const TransactionGetter = {
  transactions: (state) => state.transactions
};

export default TransactionGetter;
